import type { Location } from '@/contexts/LocationContext';

/**
 * Production navigation must never offer an inactive warehouse or a location
 * that is inventory-only. The context is already permission-scoped, so this
 * deliberately does not attempt to reimplement access control in the client.
 */
export function isProductionCentre(location: Location): boolean {
  return location.is_active !== false && location.production_enabled !== false;
}

export function getProductionCentres(locations: Location[]): Location[] {
  return locations.filter(isProductionCentre);
}

/** Resolve a selection against the live permission-scoped location list. */
export function getSelectedProductionCentre(
  locations: Location[],
  selectedLocation: Location | null,
): Location | null {
  if (!selectedLocation) return null;

  return locations.find(
    (location) => location.id === selectedLocation.id && isProductionCentre(location),
  ) ?? null;
}
